
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import NButton from '@/uikit/buttons/NButton.vue';
import NDropdown from '@/uikit/dropdown/NDropdown.vue';
import NDropdownItem from '@/uikit/dropdown/NDropdownItem.vue';
import NIcon from '@/uikit/icons/NIcon.vue';
import { ListItem } from '@/components/events/types';
import { alertModule } from '@/store/application/alert.module';

@Options({
  name: 'NotificationHeader',
  components: { NButton, NDropdown, NDropdownItem, NIcon },
  emits: ['acknowledge-action', 'show-events-action']
})
export default class NotificationHeader extends Vue {
  get actions(): ListItem[] {
    return [
      { label: this.$t('common.show_events'), name: 'show-events', icon: 'show-events' }
      // { label: this.$t('common.acknowledge_all'), name: 'acknowledge-all', icon: 'done-all' } //  до лучших времен, пока не прояснится что делать с продуктом мульти + папитир
    ];
  }

  get isPlay() {
    return alertModule.isPlay;
  }

  get isDisabled() {
    return alertModule.isDisabled;
  }

  get muteIcon() {
    return alertModule.isMute ? 'unmute' : 'mute';
  }

  get muteLabel() {
    const token = alertModule.isMute ? 'common.unmute' : 'common.mute';
    return this.$t(token);
  }

  toggleMute() {
    alertModule.toggleMute();
  }

  actionHandler(name: string) {
    switch (name) {
      case 'acknowledge-all':
        this.$emit('acknowledge-action');
        break;
      case 'show-events':
        this.$emit('show-events-action');
    }
  }
}
